import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import _findIndex from "lodash/findIndex";
import { COLLAPSED_HEIGHT_OPTIONS } from './expandable-content.module.less';
/**
 * @todo This should probably come from 'base-styles'
 * We need to avoid getComputedStyle as it synchronously forces a layout reflow which reduces performance.
 * @see {@link https://stackoverflow.com/questions/36532307/rem-px-in-javascript}
 */

export var convertRemToPixels = function convertRemToPixels(rem) {
  return rem * 16;
};
/**
 * For content that is toggleable itself, ensure that we do not hijack behavior
 * of nested interactbles like links or buttons should they be present.
 */

export var isValidInteractable = function isValidInteractable(event) {
  var currentTarget = event.currentTarget,
      target = event.target;
  var nodeName = target.nodeName;
  return nodeName === 'A' || nodeName === 'BUTTON' && target !== currentTarget;
};
/**
 * Retreive the calculated rem value derived for the height option.
 * These values are calculated statically within the 2D array export from the stylesheet.
 */

var parsedOptionsArray = COLLAPSED_HEIGHT_OPTIONS.split(/[ ,]+/);
export var retriveRemValueForHeightOption = function retriveRemValueForHeightOption(collapsedHeightOption) {
  return parsedOptionsArray[_findIndex(parsedOptionsArray, function (option) {
    return option === collapsedHeightOption;
  }) + 1];
};
export var buildAnalyticsEntityName = function buildAnalyticsEntityName(name) {
  return name === null || name === void 0 ? void 0 : name.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};